const abortError = () => Object.assign(new Error('다운로드가 취소되었습니다.'), { name: 'AbortError' })
const defaultSleep = (ms, signal) => new Promise((resolve, reject) => {
  const cancel = () => { clearTimeout(timer); reject(abortError()) }
  const timer = setTimeout(() => { signal?.removeEventListener('abort', cancel); resolve() }, ms)
  signal?.addEventListener('abort', cancel, { once: true })
  if (signal?.aborted) cancel()
})
const header = (headers, name) => headers?.[name] ?? headers?.[name.toLowerCase()]
const filenameFrom = headers => {
  const value = header(headers, 'content-disposition') || ''
  const utf8 = value.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8) { try { return decodeURIComponent(utf8[1]) } catch (error) { return utf8[1] } }
  return value.match(/filename="?([^";]+)"?/i)?.[1] || ''
}
async function jsonBody(data) {
  if (data instanceof Blob) return JSON.parse(await data.text())
  return data
}

export async function downloadCSIssueAttachment(api, issueId, attachmentId, options = {}) {
  try { return await runDownload(api, issueId, attachmentId, options) }
  catch (error) {
    if (error?.response?.data instanceof Blob) {
      try { error.response.data = await jsonBody(error.response.data) } catch (parseError) { /* Preserve original HTTP failure. */ }
    }
    throw error
  }
}

async function runDownload(api, issueId, attachmentId, options) {
  const { signal, pollIntervalMs = 1500, timeoutMs = 120000, sleep = defaultSleep, onProgress, save } = options
  if (signal?.aborted) throw abortError()
  const started = Date.now()
  let response = await api.downloadAttachment(issueId, attachmentId, { signal })
  if (signal?.aborted) throw abortError()
  if (response.status !== 202) {
    const result = { blob: response.data, filename: filenameFrom(response.headers) }
    if (save) await save(result.blob, result.filename)
    return result
  }
  const pending = await jsonBody(response.data)
  if (!pending?.job_id) throw new Error('첨부 파일 준비 작업을 확인할 수 없습니다.')
  let ready = false
  while (!ready) {
    if (signal?.aborted) throw abortError()
    if (Date.now() - started >= timeoutMs) throw new Error('첨부 파일 준비 시간이 초과되었습니다.')
    const status = await api.getExportStatus(pending.job_id, { signal })
    if (signal?.aborted) throw abortError()
    onProgress?.(status)
    ready = status.download_ready === true
    if (ready) break
    if (/fail|error/i.test(status.status || '')) throw new Error('첨부 파일 준비에 실패했습니다.')
    await sleep(pollIntervalMs, signal)
  }
  if (signal?.aborted) throw abortError()
  response = await api.downloadExport(pending.job_id, { signal })
  if (signal?.aborted) throw abortError()
  const result = { blob: response.data, filename: filenameFrom(response.headers) }
  if (save) await save(result.blob, result.filename)
  return result
}
